var NavigationState = /** @class */ (function () {
    function NavigationState() {
        this.infiniteScrolling = false;
        this.navItemSource = Array();
        this.currentPageActiveComponent = '';
        this.currentPageComponents = [];
        this.vhValue = 0;
        this.scrollState = 'scrollState1';
    }
    return NavigationState;
}());
export { NavigationState };
